<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="fixed top-6 left-1/2 -translate-x-1/2 z-[9999] w-full max-w-md px-4"
    >
      <div
        :class="[
          'rounded-lg shadow-lg p-4 flex items-start gap-3 border-l-4',
          alert.type === 'success' &&
            'bg-green-50 border-green-500 text-green-800',
          alert.type === 'error' && 'bg-red-50 border-red-500 text-red-800',
          alert.type === 'warning' &&
            'bg-yellow-50 border-yellow-500 text-yellow-800',
          alert.type === 'info' && 'bg-blue-50 border-blue-500 text-blue-800',
        ]"
      >
        <Icon
          :icon="alert.icon || 'mdi:information-outline'"
          class="mt-1"
          width="24"
          height="24"
        />
        <div class="flex-1 text-sm leading-relaxed">
          <p>{{ alert.message }}</p>
        </div>
        <button
          class="text-gray-400 hover:text-gray-600 text-lg font-bold leading-none"
          @click="close"
        >
          ×
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { Icon } from "@iconify/vue";

const props = defineProps<{
  modelValue: boolean;
  alert: {
    message: string;
    icon?: string;
    code?: string | number;
    type?: "success" | "error" | "info" | "warning";
  };
  autoClose?: boolean;
  duration?: number;
}>();

const emit = defineEmits(["update:modelValue"]);

const visible = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => {
    visible.value = val;
    if (val && props.autoClose) {
      setTimeout(() => close(), props.duration || 4000);
    }
  },
  { immediate: true }
);

const close = () => {
  visible.value = false;
  emit("update:modelValue", false);
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
